import {
    IBS_FETCH,
    IBS_FETCH_ALL,
    IBS_IS_FETCING,
    IBS_API,
    IB_EDIT,
    IB_FILTER,
} from 'constants/ibs'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Companies
export const ibSave = (data) => (dispatch, state) => {
    let action;
    if (data.ibId)
        action = put;
    else
        action = post;
    dispatch(ibsIsFetching(true))
    return action(IBS_API, data)
        .finally(e => dispatch(ibsIsFetching(false)))

}



//Feth ib by id
export const ibFetch = (id) => (dispatch, state) => {
        dispatch(ibsIsFetching(true));
        return get(IBS_API + '/' + id)
            .finally(e => dispatch(ibsIsFetching(false)))
}

export const getIbBalance = (id, time) => (dispatch, state) => {
    dispatch(ibsIsFetching(true));
    return get(IBS_API + '/' + id + '/balance-in-certain-time',{
              time
             }).then((resp) => resp)
                     .finally(e => dispatch(ibsIsFetching(false)))
}

export const getIbWithdrawalBalance = (id, time) => (dispatch, state) => {
    dispatch(ibsIsFetching(true));
    return get(IBS_API + '/' + id + '/withdrawal-balance',{}).then((resp) => resp)
                     .finally(e => dispatch(ibsIsFetching(false)))
}

//Feth all ibs
export const ibsFetch = (ibName,loading=true) => (dispatch, state) => {
    dispatch(ibsIsFetching(loading));
    const filter = state().ibs.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])

    let params = {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        }

    if(ibName) {
        params.filter = ibName
    }
    
    return get(IBS_API, params)
        //Array->Obj[ibId]{...ibinformation}
        //for easy access of ib by his id
        .then((e) => {
            dispatch(ibsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                ibFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(ibsIsFetching(false)))

}

export const ibsFetchAll = (ibName) => (dispatch, state) => {
    dispatch(ibsIsFetching(true));

    let params = {
            size: 1000000,
            sort: 'firstName,asc'
        }

    if(ibName) {
        params.filter = ibName
    }

    return get(IBS_API +'/list',params)
        .then((e) => {
            dispatch(ibsFetchedAll(e.content))
            return e
        })
        //disable loading
        .finally(e => dispatch(ibsIsFetching(false)))
}

export const ibsCurrentFetch = () => (dispatch) => {
    dispatch(ibsIsFetching(true));
    
    return get(IBS_API + '/current')
            .then((e) => {
                    dispatch(ibsFetched([e.content]))
                    return e
            })
            .finally(e => dispatch(ibsIsFetching(false)))
}

//Remove one ib
export const ibRemove = (id) => (dispatch, state) => {
    dispatch(ibsIsFetching(true))
    return remove(IBS_API + '/' + id)
        //Array->Obj[ibId]{...ibinformation}
        //for easy access of ib by his id
        .finally(e => dispatch(ibsIsFetching(false)))
}

export const ibsFetchFilter = (ibName,loading=true) => (dispatch, state) => {

    dispatch(ibsIsFetching(loading));
    const filter = state().ibs.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])

    let params = {
            size: 1000000,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        }

    if(ibName) {
        params.filter = ibName
    }

    return get(IBS_API, params)
        .then((e) => {
            dispatch(ibsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                ibFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(ibsIsFetching(false)))
}

export const ibsFetchAllFilter = (ibName,loading=true) => (dispatch, state) => {

    dispatch(ibsIsFetching(loading));
    const filter = state().ibs.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])

    let params = {
            size: 1000000,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        }

    if(ibName) {
        params.nameFilter = ibName
    }

    return get(IBS_API, params)
        .then((e) => {
            dispatch(ibsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                ibFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(ibsIsFetching(false)))
}

export const ibsFetched = (payload) => ({ type: IBS_FETCH, payload: payload })
export const ibsFetchedAll = (payload) => ({ type: IBS_FETCH_ALL, payload: payload })
export const ibsIsFetching = (payload) => ({ type: IBS_IS_FETCING, payload: payload })
export const ibEdit = (id, data) => ({ type: IB_EDIT, payload: data })
export const ibFilter = (data) => ({ type: IB_FILTER, payload: data })


// WEBPACK FOOTER //
// ./src/actions/ibs.js